import { useEffect, useRef, useState } from "react";
import { useInView } from "framer-motion";
import { Volume2, VolumeX } from "lucide-react";
import { T } from "@/constants/testIds";

export default function VideoTile({ src, poster, channel, title, caption, index }) {
  const wrap = useRef(null);
  const vid = useRef(null);
  const inView = useInView(wrap, { margin: "-10%" });
  const [muted, setMuted] = useState(true);

  useEffect(() => {
    const v = vid.current;
    if (!v) return;
    if (inView) v.play().catch(() => {});
    else v.pause();
  }, [inView]);

  const toggle = () => {
    const v = vid.current;
    if (!v) return;
    v.muted = !muted;
    setMuted(!muted);
    v.play().catch(() => {});
  };

  return (
    <div ref={wrap} data-testid={`${T.reelTile}-${index}`} className="group">
      <div className="tv aspect-square">
        <video
          ref={vid}
          src={src}
          poster={poster}
          muted={muted}
          loop
          playsInline
          preload="metadata"
          className="w-full h-full object-cover"
        />
        <div className="absolute top-3 left-3 z-10 flex items-center gap-2">
          <span className="sticker sticker-ink !text-[0.6rem] !py-1 !px-2.5">
            <span className="live-dot" /> {channel}
          </span>
        </div>
        <button
          onClick={toggle}
          data-testid={`${T.reelSound}-${index}`}
          aria-label={muted ? "Unmute" : "Mute"}
          className="absolute bottom-3 right-3 z-10 w-10 h-10 rounded-full bg-ink/80 border border-white/20 text-paper flex items-center justify-center hover:bg-[color:var(--lime)] hover:text-ink transition-colors"
        >
          {muted ? <VolumeX size={16} /> : <Volume2 size={16} />}
        </button>
      </div>
      <div className="mt-4 flex items-start justify-between gap-4">
        <div>
          <div className="font-display text-lg md:text-xl uppercase text-paper">{title}</div>
          <div className="text-sm text-paper/55 mt-1">{caption}</div>
        </div>
      </div>
    </div>
  );
}
